// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 1H5V9.58579L3 11.5858V23H21V1ZM11 8H9V5H11V8ZM14 8H12V5H14V8ZM15 8V5H17V8H15Z"}}]};

const SdCardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sd-card-filled',
    ref,
    icon: element,
  },
));

SdCardFilledIcon.displayName = 'SdCardFilledIcon';

export default SdCardFilledIcon;
